$('body').ready(function() {
  // delivery country selection
  $('[data-delivery-country="United Kingdom"]').addClass('active');
  $('[data-delivery-country]').click(function(e) {
    const button = e.target.closest('button');
    if (!button) return;
    const country = button.dataset.deliveryCountry;
    $('[data-delivery-country]').removeClass('active'); 
    button.classList.add('active');
    $('[data-selected-delivery-country]').attr('data-selected-delivery-country', country).text(country).trigger('change');
    $('[data-selected-country-delivery-range]').addClass('hidden');
    $(`[data-selected-country-delivery-range="${country}"]`).removeClass('hidden');
  });
  //end delivery country selection

  //PDP trouser picker
  $('.dropdown-list-item').click(function() {
    const varianId = this.dataset.variantId;
    const productId = this.dataset.productId;
    $('variant-picker').attr('data-select-trouser-variant-id', varianId);
  });
  //end PDP trouser picker
  // CB fancybox
  Fancybox.bind("[data-fancybox]", {
    
  });
  // Cb end fancybox
  // CB video play btn
  $('.cb-video-play-button').click(function() {
    const thumbnail = $('[data-media-type="video"], [data-media-type="external_video"]');
    thumbnail.click();
  });
  // CB end video play btn
  // CB size chart country select
  $('button[data-sizes-for-country]').click(function(e){
    $('button[data-sizes-for-country]').removeClass('active');
    this.classList.add('active');
    const countrySelect = this.dataset.sizesForCountry;
    $('[data-sizes-for-country-content]').addClass('hidden');
    $(`[data-sizes-for-country-content="${countrySelect}"]`).removeClass('hidden');
    $('[data-measurement-units="in"]').each(function(){
      this.click();
    });
  });
  // CB end size chart country select
  // CB inches to cm convert
  $('button[data-measurement-units]').click(function(e) {
    const container = this.closest('[data-measurement-buttons-for]');
    container.querySelectorAll('button').forEach(el => el.classList.remove('active'));
    this.classList.add('active');
    const clickedUnits = this.dataset.measurementUnits;
    const unitsForTable = container.dataset.measurementButtonsFor;
    let $table = $(`[data-size-table="${unitsForTable}"]`);
    $table.find('[data-inches]').each(function(){
      const inches = this.dataset.inches;
      if (clickedUnits === 'cm'){
        if(inches.includes('-') || this.classList.contains('cb-round-ceil')){
          const cm = inches.split('-').map(val => Math.ceil(+val * 2.54)).join(' - ');
          this.textContent = cm;
        } else {
          const cm = +inches * 2.54;
          this.textContent = `${Number(cm.toFixed(1))}`;
        }
      } else if (clickedUnits === 'in'){
        this.textContent = inches;
      }
    });
  });
  // CB end inches to cm convert
  // CB product variant picker
  if ($('[data-size-label] input[checked]').length){
    const initialSelect = $('[data-size-label] input[checked]');
    const initialOptionValue = initialSelect.closest('[data-size-label]').attr('data-option-value');
    const initialShortOptionValue = initialSelect.closest('[data-size-label]').attr('data-short-option-value');
    let initalLabelText = initialShortOptionValue;
    if (initialOptionValue.toLowerCase() !== initialShortOptionValue.toLowerCase()){
        initalLabelText = initalLabelText + ' | ' + initialOptionValue;
      }
    $('[data-option-value-label]').text(initalLabelText);
  }
  $('variant-picker.cb-size-picker').change(function(e){
    const optionValue = e.target.closest('[data-size-label]')?.getAttribute('data-option-value');
    if (!optionValue) return;
    const shortOptionValue = e.target.closest('[data-size-label]').getAttribute('data-short-option-value');
    let labelText = shortOptionValue;
    if (optionValue.toLowerCase() !== shortOptionValue.toLowerCase()){
      labelText = labelText + ' | ' + optionValue;
    }
    $('[data-option-value-label]').text(labelText);
  });
  // CB end product variant picker
  //CB judge me widget modify
  const targetNode = document.querySelector('body.product-page main')
  if (targetNode) {
    let found = false;
    const observer = new MutationObserver((mutationsList, observer) => {
      var $titleEl = $('.jdgm-rev-widg:not([data-number-of-reviews="0"]) .jdgm-rev-widg__title');
      if ($titleEl.length && found === false){
        found = true;
        // update title text
        const text = $titleEl.text().split(' ')[1];
        var $title = $('<h3>').addClass('cb-jdgm-rev-widg__title').text(text);
        $titleEl.after($title);
        $titleEl.remove();
      }
    });
    
    const config = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    };
      
    observer.observe(targetNode, config);
  }
  //CB end judge me widget modify//CB end judge me widget modify
  // CB add date and country iso code to contact form input
  const contactFormNode = document.querySelector('.contact-form-wrapper');
  if (contactFormNode) {
    const countryIsoCode = contactFormNode.dataset.countryIsoCode;
    const contactFormObserver = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches('button.submit') || node.querySelector('button.submit')) {
                $('.contact-form-wrapper button.submit').click(function() {
                  const now = new Date();
                  const options = { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric', 
                    hour: 'numeric', 
                    minute: '2-digit', 
                    hour12: true 
                  };
                  let formattedDate = now.toLocaleString(countryIsoCode, options);
                  if (countryIsoCode === 'IE' || countryIsoCode === 'GB'){
                    formattedDate = now.toLocaleString('en-US', options);
                  } 

                  let finalDate = formattedDate;
                  if (countryIsoCode === 'NL') {
                    finalDate = finalDate.replace('p.m.', 'uur')
                  } else if (countryIsoCode === 'DE'){
                    finalDate = finalDate.replace('PM', 'Uhr')
                  }
                  $('.contact-form-wrapper .cb-contact-date input').val(finalDate);
                  $('.contact-form-wrapper .cb-country-iso-code input').val(countryIsoCode);
                });
              }
            }
          });
        }
      }
    });
    const contactFormObserverConfig = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    };
    contactFormObserver.observe(contactFormNode, contactFormObserverConfig);
  }
  // CB add date and country iso code to contact form input
  // Update product price when select/unselect bundle item

  const calcBundlesSum = function() {
    let finalPrice = 0;
    $('.cb-bundle .cb-input:checked').each(function(index, el) {
      finalPrice += +el.dataset.price;
    });
    
    const formattedPrice = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(finalPrice / 100);

    const payIn3FormattedPrice = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(finalPrice / 100 / 3);

    const finalFormatedPrice = $('.cb-bundle .cb-input').data('currency').replace('moneyValue', formattedPrice);
    const payIn3FinalFormatedPrice = $('.cb-bundle .cb-input').data('currency').replace('moneyValue', payIn3FormattedPrice);
    
    $('.product-info .product-price .regular-price').text(finalFormatedPrice);
    $('.product-info .product-price .cb-pay-in-3-price').text(payIn3FinalFormatedPrice);
  }
  calcBundlesSum();
  $('.cb-bundle .cb-input').on('change', function(){
    calcBundlesSum();
  });
  // end Update product price when select/unselect bundle item
  $('.cb-bundle .dropdown-list-item').on('click', function(){
    const optioValueId = $(this).data('option-value-id');
    const shortOptionValue = $(this).find('.cb-short-option-value').text();
    var $span = `<span class="cb-dropdown-activator-short-option-value">${shortOptionValue}</span>`;
    $(this).closest('variant-picker').find('button[data-dropdown-activator]').prepend($span);
    calcBundlesSum();
  });
});